export default __webpack_public_path__ + "b5e47f42623cb0f856fd71c996e8b7bd.mp4";